/**
 * Keeps what plugins add in step with the plugin list: their windows become windows of the
 * window manager (drawn by `windows/plugin-view/PluginWindow`), and their commands
 * (`plugin:<id>:<command>`) can be run by shortcuts and menus.
 *
 * Wired here, in the shell, because it joins a service (`pluginViews`) to a window component.
 */
import { createEffect } from "solid-js";
import { PluginWindow } from "../windows/plugin-view/PluginWindow";
import type { App } from "./context";

/** Follows the plugin list for the life of the app. Call inside a Solid root. */
export function installPluginWindows(app: App): void {
  app.commands.addResolver((name) => app.plugins.resolve(name));
  createEffect(() => {
    app.wm.setExtra(app.pluginViews.windows().map((w) => ({ id: w.key, title: w.title, group: "Plugins", component: PluginWindow })));
  });
}
